module.exports = __webpack_public_path__ + "static/media/search.690e7aa6.png";